/* eslint-disable import/prefer-default-export */

const styleGuideClasses = [
  'display1',
  'display2',
  'display3',
  'display4',
  'display5',
  'cardTitle1',
  'cardTitle2',
  'cardTitleHidden',
  'lead1',
  'lead2',
  'p1',
  'p2',
  'label',
  'cardSubtitle',
  'cardLabel',
  'continueWatchingCardLabel',
]

export { styleGuideClasses }
